import styled, { css } from 'styled-components';
import { breakpoint } from 'styles/globals';
import { type Theme, getColor } from 'styles/theme';

export const Wrapper = styled.div<{ theme: Theme; $hasTOC: boolean }>`
  padding: 40px 16px;
  color: ${getColor('textPrimary')};
  background-color: ${getColor('surfaceSecondary')};
  border-bottom: ${({ $hasTOC }) =>
    css<{ theme: Theme }>`4px solid ${getColor($hasTOC ? 'surfaceSecondary' : 'borderAccentPrimary')}`};

  & > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 40px;
    // the header wrapper overflows the page container (1440px) but we want to ensure that its content doesn't
    max-width: calc( 1440px - (2 * var(--Grid-Margin)));
  }

  h1 {
    text-align: center;
  }

  img {
      max-width: min(100%, 450px);
      object-fit: contain;
  }
  
  @media (${breakpoint.mdMin}) {
    padding: 40px 24px;
  }

  @media (${breakpoint.lgMin}) {
    padding: 40px;
    border-bottom: 4px solid ${getColor('borderAccentPrimary')};
    div {
      flex-direction: row;

    h1 {
      text-align: left;
    }

    & > span {
      max-width: 36%;
    }
    }
  }

  @media (${breakpoint.xlMin}) {
    & > div {
      margin-left: auto;
      margin-right: auto;
    }
  }
`;
